import { CarePlanCreationInfoWithPrescription } from "@/uiKit/organisms/PatientCreationAndRenewal/CarePlan/CarePlanCreation.ts";
import { PatientInfo } from "@/uiKit/organisms/PatientCreationAndRenewal/PatientInfo/PatientInfo.ts";
import { GeneratePrescriptionInfo } from "@/uiKit/organisms/PatientCreationAndRenewal/PrescriptionInfo/PrescriptionInfo.ts";
import { WizardAction, WizardState, wizardUtils } from "@/utils/wizardUtils.ts";

export type PatientInfoStep = {
  step: "PatientInfo";
  data: PatientInfo;
};

export type CarePlanInfoStep = {
  step: "CarePlan";
  data: CarePlanCreationInfoWithPrescription;
};

export type PrescriptionInfoStep = {
  step: "PrescriptionInfo";
  data: GeneratePrescriptionInfo & {
    prescription: Blob;
  };
};

export type PrescriptionSigningStep = {
  step: "PrescriptionSign";
  data: undefined;
};

export type PatientCreationSteps = [PatientInfoStep, CarePlanInfoStep, PrescriptionInfoStep, PrescriptionSigningStep];
export type PatientCreationState = WizardState<PatientCreationSteps>;
export type PatientCreationAction = WizardAction<PatientCreationSteps>;
export const patientCreationWizard = wizardUtils<PatientCreationSteps>([
  "PatientInfo",
  "CarePlan",
  "PrescriptionInfo",
  "PrescriptionSign",
]);
